import type { CalendarEventDto } from '../../../api/calendar';
import { inclusiveEndDayNumber, localDayNumber } from '../recurrence-dates';

/**
 * 하루종일 · 2일 이상 일정은 칸을 «유형색으로 채운다» (2026-10-14 사용자 지시).
 *
 * 종전(2026-09-09 색 언어 통일)은 모든 칩이 바탕 없이 «왼쪽 유형색 선»만 썼다. 이제 하루종일·여러 날
 * 일정만 바탕을 유형색으로 옅게 채워 «기간»이 한눈에 보이게 한다. 시각 일정(하루 안)은 종전 그대로.
 * ⚠ 글자는 본문색 그대로 읽혀야 하므로 진하게 칠하지 않고 섞는다(유형색 22% + 바탕).
 */
const LONG_EVENT_FILL_PCT = 22;
/** 월간 바는 한 줄에 길게 이어져 더 진해 보인다 — 더 옅게(2026-10-14 사용자 지시 「좀만 더 연하게」). */
export const MONTH_LONG_EVENT_FILL_PCT = 14;

/**
 * ⭐ 2026-10-19 — 주간 하루종일 줄의 칩은 «진하게 꽉 채우고 흰 글자»(사용자 결정 「1,2번」 — 시간 일정과 확실히 가르기).
 *   유형색 그대로면 밝은 색(주황 등)에서 흰 글자가 안 읽혀, 검정을 조금 섞어 어둡게 한다.
 */
const ALL_DAY_SOLID_DARKEN_PCT = 12;
export function allDaySolidFill(color: string): string {
  return `color-mix(in srgb, ${color} ${100 - ALL_DAY_SOLID_DARKEN_PCT}%, #000)`;
}

/** 유형색 → 채움 바탕. pct 를 안 주면 기본(주간·일간) 진하기. */
export function longEventFill(color: string, pct: number = LONG_EVENT_FILL_PCT): string {
  return `color-mix(in srgb, ${color} ${pct}%, var(--surface))`;
}

/**
 * 하루종일이거나 2일 이상(현지 날짜 기준)에 걸친 일정인가.
 * ⚠ 날짜 셈은 월간 배치(`monthLayout.ts`)와 같다 — 종료가 자정 정각이면 그 날은 포함하지 않는다.
 */
export function isLongEvent(e: Pick<CalendarEventDto, 'isAllDay' | 'startAt' | 'endAt'>): boolean {
  if (e.isAllDay) return true;
  const s = new Date(e.startAt);
  const en = new Date(e.endAt);
  if (Number.isNaN(s.getTime()) || Number.isNaN(en.getTime())) return false;
  return inclusiveEndDayNumber(s, en) > localDayNumber(s);
}
